
import {GlobalStyles } from "../component/styles/Global.styled";
import {Section} from "..//component/styles/Section.styled";
import Header from '../component/Home/Header';
import Footer from '../component/Home/Footer';
import ScrollToTop from "../component/Home/ScrollToTop";
import Sidebar from "../component/Home/Sidebar";
import ContinueWatch from "../component/Home/ContinueWatch";
import MoviesFor from "../component/Home/MoviesFor";

function ChannelsPage() {
return (
    <div>
        <GlobalStyles />
        <ScrollToTop />
        <Header/>   

        <div className="d-flex">
            <Sidebar />
        </div>

        <ContinueWatch/>
        <MoviesFor heading="Recommendation For You"/>
        <Section />
        <Footer/> 
    </div>
    );
}

export default ChannelsPage;
